export default "__VITE_ASSET__DzkQU$AQ__"